import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  closeButton: {
    padding: 10,
  },
  container: {
    alignItems: 'center',
    borderBottomColor: colors.neutral.mist,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 20,
    paddingRight: 10,
    paddingVertical: 10,
  },
  title: {
    flex: 1,
    marginRight: 16,
    textAlignVertical: 'center',
  },
});

export default styles;
